import { ReactElement } from 'react'

import CreateVeiculos from '../../domain/usecases/CreateVeiculos'
import ListTipoCarretas from '../../domain/usecases/ListTipoCarretas'
import VeiculoRespository from '../../infra/repositories/VeiculosRepository'
import ValidateAnttImpl from 'modules/user/domain/usecases/ValidateAnttImpl'
import Create from '../../pages/Create'
import UserRepository from 'modules/user/infra/repositories/UserRepository'

const CreateFactory = (): ReactElement => {
  const veiculoRespository = new VeiculoRespository()
  const userRepository = new UserRepository()
  const listTipoCarretas = new ListTipoCarretas(veiculoRespository)
  const createVeiculos = new CreateVeiculos(veiculoRespository)
  const validateAntt = new ValidateAnttImpl(userRepository)
  return (
    <Create
      listTipoCarretas={listTipoCarretas}
      createVeiculos={createVeiculos}
      validateAntt={validateAntt}
    />
  )
}

export default CreateFactory
